export const PERSONAL_MAP_FILTERS = [
  { id: "all", label: "All" },
  { id: "want_to_ride", label: "Want to Ride" },
  { id: "visited", label: "Visited" },
  { id: "favorite", label: "Favorite" },
];

export const hasAnyPrivateState = (state = {}) =>
  Boolean(state.want_to_ride || state.visited || state.favorite);

export const matchesPersonalMapFilter = (state = {}, filter = "all") => {
  if (filter === "all") return hasAnyPrivateState(state);
  return Boolean(state[filter]);
};

export const filterPersonalMapEntries = (entries = [], filter = "all") =>
  entries.filter((entry) => matchesPersonalMapFilter(entry.state, filter));

export const privateStateBadges = (state = {}) => [
  state.want_to_ride ? { id: "want_to_ride", label: "Want to Ride" } : null,
  state.visited ? { id: "visited", label: "Visited" } : null,
  state.favorite ? { id: "favorite", label: "Favorite" } : null,
].filter(Boolean);

export const updateEntryState = (entries, destinationId, nextState) => {
  if (!nextState) return entries.filter((entry) => entry.destination.id !== destinationId);
  return entries.map((entry) => (
    entry.destination.id === destinationId
      ? { ...entry, state: nextState }
      : entry
  ));
};
